import { Layout } from "antd";
import ResumeDatabaseBody from "../../components/resume-database/ResumeDatabaseBody";
const ResumeDatabase = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", paddingLeft: "20px", paddingRight: "20px" }} className="max-w-6xl w-full mx-auto">
        <ResumeDatabaseBody />
      </Layout>
    </>
  );
};

export default ResumeDatabase;
